var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2ca0ff;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 795.51,
    cy: 540,
    r: 289.49
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bubble_2",
    "data-name": "bubble 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 795.51,
    cy: 540,
    r: 289.49
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M586.65,381.63c-12.57,15.21-20.46,35.57-16.15,54.82S594,472,613.41,468.66c9.6-1.63,17.9-7.43,25.78-13.15q14-10.17,27.83-20.67c12.88-9.8,26.17-20.56,31.92-35.69,6.77-17.85.55-39.81-14.58-51.45C651.59,322.5,607.67,356.2,586.65,381.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M842.77,643.54c-15.35,7.42-31.49,15.52-40.61,29.92-15.19,24-3.84,58.34,19.35,74.73s54.27,17.61,81.86,10.94c50.13-12.13,93.51-49.35,113.12-97,7.74-18.82,11.92-39.84,7.16-59.63-8.64-35.93-56.29-61.43-81.4-24.27-11.37,16.82-14,24-33.94,33.69C886.49,622.49,864.62,633,842.77,643.54Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects21);
export default __webpack_public_path__ + "static/media/objects-21.5b0d5a8bea238c821d7ed4a7748b743c.svg";
export { ForwardRef as ReactComponent };